import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ExpenseMileageConfigurationTaxTypes = {
  NO_TAX: 0,
  USER_CHOSEN_TAX: 1,
} as const

export type ExpenseMileageConfigurationTaxTypeEnum = Enum<
  typeof ExpenseMileageConfigurationTaxTypes
>
